import React from 'react'
import { Form } from 'antd'
import PropTypes from 'prop-types'

import { DirtyPrompt } from '../../../core/components/sections'

const DirtyPromptForm = ({ isDirty, children, ...rest }) => (
  <>
    <DirtyPrompt isDirty={isDirty} />
    <Form {...rest}>{children}</Form>
  </>
)

DirtyPromptForm.propTypes = {
  isDirty: PropTypes.bool,
  children: PropTypes.node.isRequired,
}

DirtyPromptForm.defaultProps = {
  isDirty: false,
}

export default DirtyPromptForm
